// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/page/appSettings.css
// module id = 8686
// module chunks = 0